import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

const savedLang = localStorage.getItem('i18nextLng') || 'kk';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: ['kk', 'ru', 'en'].includes(savedLang) ? savedLang : 'kk',
    fallbackLng: 'kk',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;